// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qwe8vnFVGTDjzuif4yNM{
    background-color: white;
    border-radius: 10px;
    width: 550px;
    padding: 20px;
}
.dW69a3_EjIWxrN5fmc28{
    margin-top: -20px;
    display: flex;
    position: relative;
    justify-content: center;
}
.zh2TT5yoZcSKjpjjgyIB{
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
}
.A5a1eUhGY5YBCfSno8N8{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.Y0CusCpG7TinuWlZGPzq{
    margin-top: -7px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/home/css/community-popup.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".popupContainer{\n    background-color: white;\n    border-radius: 10px;\n    width: 550px;\n    padding: 20px;\n}\n.type{\n    margin-top: -20px;\n    display: flex;\n    position: relative;\n    justify-content: center;\n}\n.communityPopUpClose{\n    position: absolute;\n    top: 22px;\n    right: 8px;\n    cursor: pointer;\n}\n.communityErrorMessage{\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.buttonType{\n    margin-top: -7px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupContainer": `Qwe8vnFVGTDjzuif4yNM`,
	"type": `dW69a3_EjIWxrN5fmc28`,
	"communityPopUpClose": `zh2TT5yoZcSKjpjjgyIB`,
	"communityErrorMessage": `A5a1eUhGY5YBCfSno8N8`,
	"buttonType": `Y0CusCpG7TinuWlZGPzq`
};
export default ___CSS_LOADER_EXPORT___;
